import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EpcAdd, CheckUser } from 'src/app/classes/device';
import { ToastrService } from 'ngx-toastr';
import { Subject, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MustMatch } from 'src/app/data-service/must-match.validator';

@Component({
  selector: 'app-add-epc',
  templateUrl: './add-epc.component.html',
  styleUrls: ['./add-epc.component.scss']
})
export class AddEpcComponent implements OnInit {
  private ResponseVerifiedAddEpc$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateEpc$: Subject<any> = new Subject();
  private ResponseVerifiedGetInfoEpc$: Subject<any> = new Subject();
  addEpcModule = new EpcAdd();
  checkUserModule = new CheckUser();
  epcInfo = new EpcAdd();
  editEpcObject: any = {};
  addEpcForm: FormGroup;
  message: string;
  dataObject: any = [];
  userId: any;
  isEditing: any;
  editUserName: any;
  editName: any;
  editEmail: any;
  editMobileNo: any;
  editDateofBirth: any;
  editAddress: any;
  editCompanyName: any;
  editWebsite: any;
  editCompanyEmail: any;
  editContactName: any;
  editLogo: any;
  editPassword: any;
  role: any;
  roleName: string;
  selectedFile: any;
  url: any;
  public files: any;
  uploadedImages: any;
  constructor(private fb: FormBuilder, private router: Router,
    private route: ActivatedRoute, private dashboardService: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });

  }

  ngOnInit() {
    //reactive form validation
    this.addEpcForm = this.fb.group({
      // login id, name, address, comp_nm,con_nm pattern to accept digit, letter, special char
      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      email: ['', [Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")] ],
      password: ['',[ Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.pattern("^[0-9]*$"),Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      company_name: ['',  [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      website: ['', [Validators.pattern("https?://.+")]],
      company_email: ['', [Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")] ],
      contact_name: ['',  [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      logo: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    },{
      validator: MustMatch('password', 'confirmPassword')
  }
    );
    if (this.isEditing == true) {
      this.getInfoByEpcId();
    }

  }
  //reactive form control function
  get f() { return this.addEpcForm.controls; }

  onSelectFile(event) { // called each time file input changes
      if (event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.url = reader.result;
      reader.readAsDataURL(file);
      this.uploadedImages = event.target.files;
        if (this.uploadedImages[0].type == "image/png" || this.uploadedImages[0].type == "image/jpeg" || this.uploadedImages[0].type == "image/gif") {
       if(this.uploadedImages[0].size <= 204800 && this.uploadedImages[0].size >= 2048){
          this.uploadImage();
       }else{
        this.toastr.info("Select image size between 2kb to 200kb");
        event.srcElement.value = null;

       }

      } else {
        this.toastr.info('Please select image only...');
        event.srcElement.value = null;
      }
    }else{
      this.addEpcForm.controls['logo'].reset()
    }
  }

  uploadImage() {
    this.dashboardService.uploadFile(this.uploadedImages)
      .then(
        async data => {
          if (data.status === true || data.status === 'true') {
            this.addEpcForm.patchValue({
              logo: data.resultObject
            })
            this.toastr.success("File uploaded successfully...");

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.addEpcForm.controls['logo'].reset()
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  //add epc user
  add_Epc() {
    this.addEpcModule = {
      "login_id": this.addEpcForm.controls['login_id'].value,
      "name": this.addEpcForm.controls['name'].value,
      "email": this.addEpcForm.controls['email'].value,
      "password": this.addEpcForm.controls['password'].value,
      "mobile_no": this.addEpcForm.controls['mobile_no'].value,
      "address": this.addEpcForm.controls['address'].value,
      "company_name": this.addEpcForm.controls['company_name'].value,
      "website": this.addEpcForm.controls['website'].value,
      "company_email": this.addEpcForm.controls['company_email'].value,
      "contact_name": this.addEpcForm.controls['contact_name'].value,
      "logo": this.addEpcForm.controls['logo'].value,
    }

    this.dashboardService.addEpcUser(this.addEpcModule)
      .pipe(takeUntil(this.ResponseVerifiedAddEpc$))
      .subscribe(
        async data => {
          if (data.status === true || data.status === 'true') {
            this.router.navigate(['/inject-solar/admin-user-registration/epc-users']);
            this.toastr.success(data.message);

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  //update epc
  update_Epc() {
    var epcInfo = {
      "id": this.userId,
      "login_id": this.addEpcForm.controls['login_id'].value,
      "name": this.addEpcForm.controls['name'].value,
      "email": this.addEpcForm.controls['email'].value,
      "mobile_no": this.addEpcForm.controls['mobile_no'].value,
      "address": this.addEpcForm.controls['address'].value,
      "company_name": this.addEpcForm.controls['company_name'].value,
      "website": this.addEpcForm.controls['website'].value,
      "company_email": this.addEpcForm.controls['company_email'].value,
      "contact_name": this.addEpcForm.controls['contact_name'].value,
      "logo": this.addEpcForm.controls['logo'].value,
    }
    this.dashboardService.updateEpcUser(epcInfo)
      .pipe(takeUntil(this.ResponseVerifiedUpdateEpc$))
      .subscribe(
        async data => {
          if (data.status === true || data.status === 'true') {
            this.router.navigate(['/inject-solar/admin-user-registration/epc-users']);
            this.toastr.success(data.message);;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get info by id
  getInfoByEpcId() {
    this.editEpcObject = {
      id: this.userId
    };
    this.dashboardService.getInfoByEpcId(this.editEpcObject)
      .pipe(takeUntil(this.ResponseVerifiedGetInfoEpc$))
      .subscribe(
        async data => {
          if (data.status) {
            this.editEpcObject = {};
            this.dataObject = data.resultObject;
            this.editUserName = this.dataObject.login_id;
            this.editName = this.dataObject.name;
            this.editAddress = data.resultObject.address;
            this.editCompanyName = data.resultObject.company_name;
            this.editWebsite = data.resultObject.website;
            this.editContactName = data.resultObject.contact_name;
            this.editLogo = data.resultObject.logo;
            this.editMobileNo = data.resultObject.mobile_no;
            this.editEmail = data.resultObject.email;
            this.editCompanyEmail = data.resultObject.company_email;
            this.editDateofBirth = data.resultObject.date_of_birth;
            this.addEpcForm.get('email').setValue(this.editEmail);
            this.addEpcForm.get('company_email').setValue(this.editCompanyEmail);
            this.addEpcForm.get('login_id').setValue(this.editUserName);
            this.addEpcForm.get('name').setValue(this.editName);
            this.addEpcForm.get('address').setValue(this.editAddress);
            this.addEpcForm.get('company_name').setValue(this.editCompanyName);
            this.addEpcForm.get('website').setValue(this.editWebsite);
            this.addEpcForm.get('contact_name').setValue(this.editContactName);
            this.addEpcForm.get('logo').setValue(this.editLogo);
            this.addEpcForm.get('mobile_no').setValue(this.editMobileNo);
            this.addEpcForm.get('password').setValue("Admin@123");
            this.addEpcForm.get('confirmPassword').setValue("Admin@123");
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // check user name api call
  checkUser() {
    this.checkUserModule = {
      "user_name": this.addEpcForm.controls['user_name'].value
    }
    this.dashboardService.checkUser(this.addEpcModule).subscribe(
      async data => {
        if (data.status === true || data.status === 'true') {
          this.router.navigate(['/inject-solar/add-epc']);
          this.toastr.success(data.message);
        } else {
          this.toastr.info(data.message);
        }
      },
      err => {
        return console.error(err);
      }
    );

  }

  ngOnDestroy() {
    this.ResponseVerifiedAddEpc$.next();
    this.ResponseVerifiedAddEpc$.complete();
    this.ResponseVerifiedUpdateEpc$.next();
    this.ResponseVerifiedUpdateEpc$.complete();
    this.ResponseVerifiedGetInfoEpc$.next();
    this.ResponseVerifiedGetInfoEpc$.complete();
  }

}
